import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  assignCorporateUser,
  createDealership,
  deleteDealership,
  fetchDealership,
  updateDealership
} from '../actions/dealership.actions';
import SingleState from '../states/single.state';

const initialState: SingleState = {
  loading: false,
  data: null,
  error: null,
};

const DealershipSlice = createSlice({
  name: 'dealership',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDealership.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDealership.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchDealership.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(createDealership.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDealership.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createDealership.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(deleteDealership.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDealership.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = null;
      })
      .addCase(deleteDealership.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(updateDealership.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDealership.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateDealership.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })
      .addCase(assignCorporateUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(assignCorporateUser.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(assignCorporateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })
    ;
  },
});

export const { clearError } = DealershipSlice.actions;
export default DealershipSlice.reducer;